// Generated by ts-to-zod
import { z } from 'zod';

export const auditLogObjectTypeSchema = z.literal('annotation');

export const auditLogActionSchema = z.string();

export const auditLogSourceTypeSchema = z.union([
  z.literal('user'),
  z.literal('email'),
  z.literal('hook'),
  z.literal('system'),
  z.literal('formula_fields'),
  z.literal('rules'),
]);

export const auditLogSourceActionSchema = z.string();

export const auditLogRuleRefSchema = z.object({
  ruleId: z.number().optional().nullable(),
  ruleName: z.string().optional().nullable(),
});

export const auditLogSourceDetailsSchema = z.object({
  userId: z.number().optional().nullable(),
  userEmail: z.string().optional().nullable(),
  hookId: z.number().optional().nullable(),
  hookName: z.string().optional().nullable(),
  event: z.string().optional().nullable(),
  systemAction: z.string().optional().nullable(),
  rules: z.array(auditLogRuleRefSchema).optional().nullable(),
  emailSender: z.string().optional().nullable(),
  emailSubject: z.string().optional().nullable(),
  action: auditLogSourceActionSchema.optional().nullable(),
});

export const auditLogDocumentRefSchema = z.object({
  id: z.number(),
  filename: z.string(),
});

export const auditLogAutomationBlockerRefSchema = z.object({
  id: z.number(),
  type: z.string(),
  fields: z.array(z.string()),
});

export const auditLogAssigneeRefSchema = z.object({
  id: z.number(),
  email: z.string(),
});

export const annotationFieldChangeSchema = z.union([
  z.object({
    field: z.literal('status'),
    previousValue: z.string().nullable(),
    value: z.string().nullable(),
  }),
  z.object({
    field: z.literal('queue_id'),
    previousValue: z.number().nullable(),
    value: z.number().nullable(),
  }),
  z.object({
    field: z.literal('document'),
    previousValue: auditLogDocumentRefSchema.nullable(),
    value: auditLogDocumentRefSchema.nullable(),
  }),
  z.object({
    field: z.literal('automation_blocker'),
    previousValue: auditLogAutomationBlockerRefSchema.nullable(),
    value: auditLogAutomationBlockerRefSchema.nullable(),
  }),
  z.object({
    field: z.literal('assignees'),
    previousValue: z.array(auditLogAssigneeRefSchema),
    value: z.array(auditLogAssigneeRefSchema),
  }),
  z.object({
    field: z.string(),
    previousValue: z.unknown(),
    value: z.unknown(),
  }),
]);

export const contentFieldChangeSchema = z.object({
  schemaId: z.string(),
  previousValue: z.string().nullable(),
  value: z.string().nullable(),
});

export const contentTableChangeSchema = z.object({
  schemaId: z.string(),
  rows: z.array(
    z.object({
      rowId: z.number(),
      fields: z.array(contentFieldChangeSchema),
    })
  ),
});

export const contentChangesSchema = z.object({
  data: z.object({
    fields: z.array(contentFieldChangeSchema),
    tables: z.array(contentTableChangeSchema).optional(),
  }),
  meta: z
    .object({
      schemaIdLabels: z.record(z.string()).optional(),
      queueNames: z.record(z.string()).optional(),
    })
    .optional(),
});

export const annotationChangesSchema = z.object({
  data: z.array(annotationFieldChangeSchema),
  meta: z
    .object({
      queueNames: z.record(z.string()).optional(),
    })
    .optional(),
});

export const auditLogChangesSchema = z.object({
  annotation: annotationChangesSchema.optional(),
  content: contentChangesSchema.optional(),
  document: z.array(z.unknown()).optional(),
  labels: z.array(z.unknown()).optional(),
});

export const auditLogEntrySchema = z.object({
  organizationId: z.number(),
  timestamp: z.string(),
  username: z.string().nullable(),
  objectId: z.number(),
  objectType: auditLogObjectTypeSchema,
  action: auditLogActionSchema,
  sourceType: auditLogSourceTypeSchema.nullable(),
  sourceDetails: auditLogSourceDetailsSchema.nullable(),
  content: z.object({
    requestId: z.string().optional().nullable(),
    changes: auditLogChangesSchema,
  }),
});
